module.exports = __webpack_public_path__ + "static/media/oberflex-noyergrispoudre-2560x1440.4069f0bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyergrispoudre-2560x1440.jpg
// module id = 1045
// module chunks = 37